document.addEventListener('change', (e) => {
  const target = e.target
  if(!target.closest(".sort-toggle")) { return }

  if(target.form) {
    target.form.requestSubmit()
  }
})
